import React, { useState } from "react";
import { Upload, Button, message, Spin } from "antd";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import { uploadBackground, uploadLogo } from "../actions/stampcard_action";
import { useSelector } from "react-redux";

const StampImageUploader = ({ label, onChange, initialPreviewUrl }) => {
  const accUrn = useSelector((state) => state.account.urn);
  const businessSlug = useSelector((state) => state.account.businessSlug);

  const [previewUrl, setPreviewUrl] = useState(initialPreviewUrl || null);
  const [loading, setLoading] = useState(false);

  const beforeUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);

    try {
      let res;
      if (label === "Logo") {
        res = await uploadLogo({ data: formData, accUrn, businessSlug });
      } else {
        res = await uploadBackground({ data: formData, accUrn, businessSlug });
      }

      const { fileName } = res || {};
      if (!fileName) throw new Error("Missing fileName in response");

      const localUrl = URL.createObjectURL(file);
      setPreviewUrl(localUrl);
      onChange({ fileName, localUrl });
      message.success(`${label} uploaded successfully`);
    } catch (err) {
      console.error(err);
      message.error(`Failed to upload ${label}`);
    } finally {
      setLoading(false);
    }

    return false; // prevent AntD from auto-uploading
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <h4>{label}</h4>

      <Upload
        accept="image/*"
        showUploadList={false}
        beforeUpload={beforeUpload}
        disabled={loading}
      >
        <Button
          icon={loading ? <LoadingOutlined /> : <UploadOutlined />}
          loading={loading}
        >
          {loading ? `Uploading ${label}...` : `Upload ${label}`}
        </Button>
      </Upload>

      {previewUrl && (
        <div style={{ marginTop: 12 }}>
          <img
            src={previewUrl}
            alt={`${label} preview`}
            style={{
              maxWidth: "100%",
              height: 100,
              border: "1px solid #ddd",
              borderRadius: 6,
              objectFit: "contain",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default StampImageUploader;
